const bulkZipForm = document.getElementById('bulkZipForm');
if (bulkZipForm) {
    bulkZipForm.addEventListener('submit', function(event) {
        event.preventDefault();
        var state = document.getElementById('stateSelect').value;
        var radius = document.getElementById('zipRadius').value;
        var queryParams = [];
    
        if (state) {
            queryParams.push('stateFilter=' + state);
        }
    
        if (radius) {
            queryParams.push('zipRadius=' + radius);
        }
    
        if (queryParams.length > 0) {
            var newUrl = '/profile' + (queryParams.length ? '?' + queryParams.join('&') : '');
            window.location.href = newUrl;
        }
    }); 
}